import globals from '@descope-ui/theme-globals';
import { TimerClass } from './component/TimerClass';
import { getThemeRefs } from '@descope-ui/common/theme-helpers';

const globalRefs = getThemeRefs(globals);
const vars = TimerClass.cssVarList;

const timer = {
  [vars.hostDirection]: globalRefs.direction,
  [vars.gap]: '0.25em',
  [vars.fontFamily]: globalRefs.fonts.font1.family,
  [vars.minHeight]: '1.5em',
  [vars.lineHeight]: '1em',
  [vars.fontWeight]: globalRefs.fonts.font1.fontWeight,
  [vars.textColor]: globalRefs.colors.surface.contrast,
  [vars.iconColor]: globalRefs.colors.surface.contrast,
  [vars.iconSize]: '1em',

  size: {
    xs: { [vars.fontSize]: '12px' },
    sm: { [vars.fontSize]: '14px' },
    md: { [vars.fontSize]: '16px' },
    lg: { [vars.fontSize]: '18px' },
  },

  textAlign: {
    right: { [vars.textAlign]: 'right' },
    left: { [vars.textAlign]: 'left' },
    center: { [vars.textAlign]: 'center' },
  },

  _fullWidth: {
    [vars.hostWidth]: '100%',
  },
};

export default timer;

export { vars };
